<template>
    <div class="list-wrapper" ref="wrapper">
        <sns-scroll-load :scrollEvent="scrollEvent" :isLoading="listLoading" :parent="$parent.$refs.parent" :fullFirstScreen="true" :show-tip-text="false" :preCount="1" @load="handleLoad"
            @loaded="handleLoaded" @nomore="handleNomore">
            <div class="item" v-positiontop="selectId == item.id || selectId == item.seq" v-for="(item, index) in tabList" :key="item.id" @click="handleItemClick(item, index)">
                <list-tab :title="item.title" :leftSlot="''" :rightSlot="computedStr(item)" :checked="selectId == item.id || selectId == item.seq" :had-read="item.hasRead">
                </list-tab>
            </div>
            <template v-slot:tip>
                <v-loading v-show="!loadOver">
                </v-loading>
                <div v-show="loadOver" class="over-tip sub-text-88">
                    没有更多了</div>
            </template>
        </sns-scroll-load>
    </div>
</template>

<script>
import listTab from "@/base/list_tab";
import * as client from "@/common/js/client";
import * as utils from "@/common/js/utils";
import vLoading from "@/common/ui/loading";
import format from "./format";
export default {
    name: "news_list",
    data() {
        return {
            scrollEvent: 0,
            tabList: [],
            selectId: "",
            model: {},
            listLoading: false,
            loadTime: 0,
            loadOver: false,
            tabListWatch: false,
            lockFlag: true, //只能进一次
            increaseId: 0,
        };
    },
    props: {
        value: Object,
        detail: Object,
        canload: {
            type: Boolean,
            default() {
                return true;
            },
        },
    },
    inject: ["pageDetail", "selectArticle"],
    filters: {
        formatListDate(item, vm) { },
    },
    components: {
        listTab,
        vLoading,
    },
    computed: {},
    beforeCreate: function () { },
    created: function () {
        this.listLoading = true;
        const that = this;

        //数据加载逻辑；createData会场从客户端获取数据；如果客户端有缓存情况下，读取缓存数据,如果数量不够preCount的数量时会自动触发
        // @load  中的函数；@load中的函数为下拉加载时触发的函数。一般是服务端请求；具体可查看format.js中对应类型的加载函数； 

        format[this.detail.type].createData.call(this).then((res) => {
            this.tabList = res;
            this.listLoading = false;
            //初始化定位
            function formatDate(str) {
                return new Date(str * 1000).toLocaleString()
            }
            // debugger
            if (that.pageDetail.objid && that.pageDetail.objid != 0) {
                console.log(`有objid 优先定位，objid为客户端内的文章对应指针`);
                //整合所有入口的获取id逻辑，感觉还是有问题。如果真要做好，得把资讯树的接口给理清楚，才能以最少请求获得想要的东西！
                this.$client.getSeqByObjid(this.pageDetail).then(getSeqRes => {
                    //this.$refs.newsList.handleItemClick(res)
                    if (getSeqRes) {
                        this.handleItemClick(getSeqRes)
                    } else {
                        console.log(`客户端定位seq查询结果为空，res=`, getSeqRes);
                        this.handleItemClick(res[0])
                    }

                    //前逻辑
                    //this.tabList.filter(item => { if (this.selectId == item.id || this.selectId == item.seq) { item.hasRead = true; } })
                })
            } else if (this.pageDetail.time) {
                //todo 个股分时 已修复部分;
                const time = this.pageDetail.time;
                const today = new Date(time * 1000);
                const date = today.getDate();
                const month = today.getMonth();
                const hour = today.getHours();
                const maxTime = +this.pageDetail.time + 60 * 60 * 24

                let targetItem = this.tabList[0];
                console.log('this.pageDetail.time', formatDate(time));
                console.log(`信息地雷需要定位，无objid`);
                this.tabList.filter(item => {
                    // console.log('%c item.id', 'color:red', item.id);
                    const target = new Date(item.time * 1000)
                    const targetDate = target.getDate();
                    const targetMonth = target.getMonth();
                    const targetHour = target.getHours();
                    // 可能存在的问题：无法定位时间为00:00:00的文章，后续优化通过objid定位
                    // 个股分时的信息地雷（time不是00:00:00,查找时间相等的新闻）
                    if (hour !== 0) {
                        if (item.time == time && this.lockFlag) {
                            console.log(`this.pageDetail.time match ${item.id}`);
                            this.lockFlag = false
                            targetItem = item;
                        }
                    }

                    //K线给的time是凌晨零点零分零秒的时间,取的是当日最新的一篇
                    if (month == targetMonth && date == targetDate && item.time < maxTime && this.lockFlag) {
                        console.log(`this.pageDetail.time match ${item.id}`);
                        targetItem = item;
                        this.lockFlag = false
                    }
                })
                this.handleItemClick(targetItem)
            } else {
                console.log('selected 为空，所有默认选中第一个');
                if (res.length) {
                    this.handleItemClick(res[0])
                } else {
                    console.log(`从客户端没有获取数据`);
                }
                //todo 无数据时兜底
            }

        });
        // 未知代码段，应该是用于某些定位失效的情况下，再次定位的功能
        this.$nextTick((_) => {
            this.$parent.$refs.parent.addEventListener("scroll", () => {
                this.scrollEvent = this.$parent.$refs.parent.scrollTop;
            });
        });
    },
    watch: {
        tabList: {
            handler() {
                if (this.tabListWatch) {
                    // this.watchFunc();
                    this.tabListWatch = false;
                }
            },
        },
    },
    mounted: function () { },
    methods: {
        getCurrentSeq() {
            window.statSeq = this.selectArticle().seq || this.selectArticle().id;
            return this.selectArticle().seq || this.selectArticle().id;
        },
        computedStr(item) {
            
            let timeRules = {}
            let showTime = (item.cTime || item.ctime || item.time) * 1000
            if(this.detail.type === "notice"){
                if(item.cTime === 0 || item.ctime === 0){
                    timeRules = {
                        "1d": "{YYYY}-{MM}-{DD}",
                        "1y": "{YYYY}-{MM}-{DD}",
                        "xy": "{YYYY}-{MM}-{DD}",
                    }
                }else{
                    if(!(new Date(showTime).toDateString() === new Date().toDateString())){
                        timeRules = {
                            "1d": "{YYYY}-{MM}-{DD}",
                            "1y": "{YYYY}-{MM}-{DD}",
                            "xy": "{YYYY}-{MM}-{DD}",
                        }
                        showTime = item.time || item.ctime
                    }else{
                        timeRules = {
                            "1d": "{hh}:{mm}",
                            "1y": "{YYYY}-{MM}-{DD}",
                            "xy": "{YYYY}-{MM}-{DD}",
                        }
                    }
                }
            }else{
                timeRules = {
                    "60s": "刚刚",
                    "60m": "{nm}分钟前",
                    "yesterday": "昨天{hh}:{mm}",
                    "24h": "{nh}小时前",
                    "1y": "{YYYY}-{MM}-{DD} {hh}:{mm}",
                    "xy": "{YYYY}-{MM}-{DD}",
                }
            }
           
            return (
                (item.source || "") +
                " " +
                this.$utils.thscSnsBaselibUtils.getPublishTime(
                    showTime,
                    timeRules
                )
            );
        },
        handleItemClick(item) {
            if (!item) {
                return
            }
            this.selectId = '';
            this.selectId = item.id || item.seq;
            let obj = JSON.parse(JSON.stringify(item))
            this.$emit('input', obj);
            this.$emit('change', obj);
            item.hasRead = true;
            this.$sendStat(`pc_newschrome_${this.getCurrentSeq()}.leftlist.click`)
        },
        selectFirst() {
            this.tabListWatch = true
            // this.handleItemClick(this.tabList[0])
        },
        watchFunc() {
            // this.handleItemClick(this.tabList[0])
        },
        handleLoad(e) {
            if (this.canload) {
                // this.$sendStat(this.$pageStat(this.getCurrentSeq(), 'content_list')('contentlistload', ++this.loadTime))
                this.$sendStat(`pc_newschrome_${this.getCurrentSeq()}.leftlist.switch`)
                this.listLoading = true;
                format[this.detail.type].followData.call(this).then(res => {
                    if (res.code == 0) {
                        this.tabList = this.tabList.concat(res.data)
                        this.listLoading = false;
                    }
                })
            } else {
                this.loadOver = true
            }
        },
        handleLoaded(e) {
            // this.loadOver = true;
        },
        handleNomore(e) {
            this.loadOver = true;
            // this.$sendStat(this.$pageStat(this.getCurrentSeq(), 'content_list')('contentlistbotreveal'))
            this.$sendStat(`pc_newschrome_${this.getCurrentSeq()}.leftlist.switchBottom`)
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../../common/style/index.less';
.list-wrapper {
    width: 243px;
    height: 100%;
    .item {
        margin-bottom: 10px;
    }
}
.over-tip {
    margin-top: 10px;
    text-align: center;
}
</style>
